import { pipe } from 'ramda';
import styled from 'styled-components';
import {
  Grid as GridAtom,
  withEditingMask,
  withExternalFilter,
  withSingleClickEdit,
} from 'components/atoms/grid';
import { withStylePreferenceProvider } from 'components/atoms/style-preference-context';
import { withStatusBar } from 'components/organisms/task-grid/plugins';

const Grid = styled(GridAtom)`
  .ag-row {
    border-color: var(--table-border-color);
  }
  .ag-react-container {
    max-width: 100%;
  }
  .multiline-text {
    max-height: var(--height-lg);
    padding-top: var(--spacing-02);
    white-space: pre-wrap;
    line-height: var(--spacing-07);
  }
  .task-grid-row-private {
    --ag-odd-row-background-color: var(--private-01);
    --ag-background-color: var(--private-01);
    --ag-row-hover-color: var(--private-02);
  }
`;

export const StyledGrid = pipe(
  pipe(
    () => Grid,
    withExternalFilter,
    withSingleClickEdit,
    withStatusBar,
    withStylePreferenceProvider({ size: 'middle' }),
    withEditingMask,
  ),
)();
